<template>
  <sui-form-field>
    <div class="ui fluid button" @click.prevent="openFileSelector()">
      Select credentials file...
    </div>
    <input class="file" type="file" @change="uploadCredentials" />
    <small class="errors" v-show="uploadError || error">
      {{uploadError || error}}
    </small>
    <small class="success" v-show="isValid">
      File has been successfully uploaded
    </small>
  </sui-form-field>
</template>

<script>
  import FormField from '@/mixins/FormField'

  export default {
    name: 'FormProviderCredentials',
    mixins: [
      FormField,
    ],
    data() {
      return {
        uploadError: null,
      }
    },
    methods: {
      openFileSelector() {
        this.$el.querySelector('input').click()
      },
      uploadCredentials(event) {
        const file = event.target.files[0]
        this.changed = true
        this.uploadError = null
        if (file) {
          const fileReader = new FileReader()
          fileReader.addEventListener('load', event => {
            try {
              this.$attrs.value = JSON.parse(event.target.result)
              this.onInput()
            } catch (e) {
              this.uploadError = e
            }
          })
          fileReader.readAsText(file)
        } else {
          this.uploadError = 'File hasn\'t been selected'
          return
        }
      },
    }
  }
</script>

<style scoped>
  .file { display: none; }
  .errors { color: #9f3a38; }
  .success { color: #3a9f38; }
</style>
